import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import {
    Container,
    Row,
    Col,
    Table,
    Card,
    CardBody,
    DropdownItem,
} from "reactstrap"
import { adminPrefix } from "configs/routePrefix"
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItemxs } from 'reactstrap';
import Paginator from "components/Common/Paginator/Paginator"
import FilterModal from "./FilterModal"
import FilterIcon from "assets/images/filter.png"
import StatusButton from "./StatusButton"
import LeadService from "services/Admin/LeadService"
import StatusModal from "./StatusModal"
import FeedbackModal from "./FeedbackModal"
import AssignSalesRepModal from "./AssignSalesRep"
import CardItem from "./CardItem"
import moment from "moment"
import "./styles.scss"
 
const LeadsList = (props) => {
    const leadService = new LeadService()
    const [status, setStatus] = useState('All')
    const [modal, setModal] = useState(false)
    const [searchWord, setSearchWord] = useState("")
    const [selectAll, setSelectAll] = useState(false)
    const [idsSelected, setIdsSelected] = useState([])
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [feedbackModal, setFeedbackModal] = useState(false);
    const [salesRepModal, setSalesRepModal] = useState(false)
    const [modalStatus, setModalStatus] = useState(false)
    const [list, setList] = useState([])
    const [filtersParams, setFilterParams] = useState(null)
    const [shouldGetData, setShouldGetData] = useState(false)
    const [pageOptions, setPageOptions] = useState({
        sizePerPage: 10,
        totalSize: 1,
    })
    const toggle2 = () => setDropdownOpen(prevState => !prevState);
    const [filterData, setFilterData] = useState({ 
        from_date: "",
       to_date: "",
       has_deal: false,
       location: null})

    const toggle = () => {
        setModal(!modal)
    }

    const OnSearchChange = (e) => {
        const search = e.target.value
        setSearchWord(search)
    }
 

    useEffect(() => {
        // debounce solution to reduce request data from api
        const timeoutId = setTimeout(() => {

            const params = {}
            if (status != 'All') params['status'] = status
            if (searchWord.trim().length) params['keyword'] = searchWord
       
            if (!!filterData ?.country?.label) params['country'] = filterData?.country?.value
            if (filterData ?.location?.length !== 0) params['location'] = filterData?.location?.map(item => item.value).join()
            if (filterData ?.has_deal) params['has_deal'] = filterData.has_deal ? 1 : 0
            if (filterData ?.from_date ?.length && filterData ?.to_date ?.length) {
                params['date_range'] = `${filterData.from_date},${filterData.to_date}`
            } else if (filterData ?.from_date ?.length) {
                params['date_range'] = `${filterData.from_date},${moment().format(`YYYY-MM-DD`)}`
            } else if (filterData ?.to_date ?.length) {
               params['date_range'] = `0,${filterData.to_date}`
            }
                
            setFilterParams({ ...params })
        }, 1000)

        return () => clearTimeout(timeoutId)

    }, [status, searchWord, filterData])

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Leads</title>
                </MetaTags>
                <Container fluid>
                    <Row className="mb-1">
                        <Col md={6}>
                            <h4>Manage Leads</h4>
                        </Col>
                    </Row>
                    <Row className="mb-1">
                        <Col md={6}>
                            <div className="form-group has-search">
                                <span className="fa fa-search form-control-feedback"></span>
                                <input type="text" className="form-control" placeholder="Search by Client Name, Unit Code, I.D" onChange={(e) => OnSearchChange(e)}
                                    value={searchWord} />
                            </div>
                        </Col>
                    </Row>
                    <Row className="mb-4 justify-content-between">
                        <Col md={10} className="mb-3">
                        <StatusButton statusValue={status} status={"All"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Wrong number"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Busy"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Unreachable"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Not interested"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Uncontacted"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Interested to buy"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Interested to sell"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"VIP"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Deal"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Contracting"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Complain"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Pending"} setStatus={setStatus} />
                        </Col>
                        <Col sm={3} md={2} className="mb-3 d-flex flex-row-reverse">

                            <button className="btn btnUpload btnHeight px-4" style={{ margin: "0" }} onClick={() => {
                                setModal(!modal)
                            }}> <img src={FilterIcon} style={{ marginRight: "5px" }} />Filter</button>
                        </Col>
                    </Row>
                    <div>
                        <Card className="w-100 mt-4">
                            <CardBody>
                                <div className="py-3">
                                    <div>
                                        <div className="table-responsive-crm table-responsive" style={{marginBottom:"11rem !important"}}>
                                            <Table>
                                                <thead>
                                                    <tr className="bgHeaderTable">
                                                        <th className="font-size-14">
                                                            <label className="m-0 d-flex" style={{gap: '8px'}}>
                                                                <input type='checkbox' checked={selectAll} name='seletAll' onChange={(e)=> {
                                                                    setSelectAll(e.target.checked)
                                                                    if(e.target.checked){
                                                                        setIdsSelected(list?.map(res=> res?.id))
                                                                    } else {
                                                                        setIdsSelected([])
                                                                    }
                                                                }} />
                                                                I.D
                                                            </label>
                                                        </th>
                                                        <th className="font-size-14">Client Name</th>
                                                        <th className="font-size-14">Phone</th>
                                                        <th className="font-size-14">Open Deals</th>
                                                        <th className="font-size-14">Sales rep</th>
                                                        <th className="font-size-14">Last Visited Date</th>
                                                        <th className="font-size-14">No of Searches</th>
                                                        <th className="font-size-14">Status</th>
                                                        <td className="removebtnhover">
                                                            {!!idsSelected?.length && <Dropdown className="dropdownWidth" color="light" isOpen={dropdownOpen} toggle={toggle2}>
                                                                <DropdownToggle caret>
                                                                    <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                                                                </DropdownToggle>
                                                                <DropdownMenu>
                                                                    <DropdownItem onClick={() => {
                                                                        let ids = String(idsSelected)
                                                                        props.history.push(`${adminPrefix}/leads/add-activity/${ids}`)
                                                                    }}>Add Activity</DropdownItem>
                                                                    <DropdownItem onClick={() => setFeedbackModal(true)}>Add Feedback</DropdownItem>
                                                                    <DropdownItem onClick={() => setModalStatus(true)}>Change Status</DropdownItem>
                                                                    <DropdownItem onClick={() => setSalesRepModal(true)}>Reassign Sales-rep</DropdownItem>
                                                                </DropdownMenu>
                                                            </Dropdown>}
                                                        </td>
                                                    </tr>
                                                </thead>
                                                <tbody >
                                                    {list.map((item, index) => {
                                                        return (
                                                            <CardItem
                                                                key={index}
                                                                item={item}
                                                                setSelectAll={setSelectAll}
                                                                idsSelected={idsSelected}
                                                                setIdsSelected={setIdsSelected}
                                                                history={props.history}
                                                                setShouldGetData={setShouldGetData}
                                                             />
                                                        )
                                                    })}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <Row className="d-flex justify-content-end">
                            <Col className="d-flex justify-content-between" md={12} sm={12}>
                                <Paginator
                                    service={leadService}
                                    pageOptions={pageOptions}
                                    setData={(data) => setList([...data])}
                                    setPageOptions={setPageOptions}
                                    filtersParams={filtersParams}
                                    shouldGetData={shouldGetData}
                                    setShouldGetData={setShouldGetData}
                                />
                            </Col>
                        </Row >
                    </div>
                    {modal ?<FilterModal
                        toggle={toggle}
                        modal={modal}
                        onSumbit={(data) => setFilterData((prevData) => ({ ...prevData, ...data }))}
                        filterData={filterData}
                    />:null}
                    {modalStatus && <StatusModal
                        modal={modalStatus}
                        toggle={() => setModalStatus(!modalStatus)}
                        idsSelected={idsSelected}
                        setShouldGetData={setShouldGetData}
                    />}
                    {feedbackModal ? <FeedbackModal
                        modal={feedbackModal}
                        toggle={() => setFeedbackModal(!feedbackModal)}
                        idsSelected={idsSelected}
                        type="list"
                        setShouldUpdateDate={() => { }}
                    /> : null}
                    {salesRepModal ? <AssignSalesRepModal
                        modal={salesRepModal}
                        toggle={() => setSalesRepModal(c => !c)}
                        idsSelected={idsSelected}
                        setShouldGetData={setShouldGetData}
                    /> : null}
                </Container>
            </div>
        </React.Fragment >
    )
}

export default LeadsList
